import PhotoSwipe, { PhotoSwipeUI_Default } from "photoswipe";
// Import Swiper and modules
import SwiperCore, {
    Navigation,
    Pagination,
    Scrollbar,
    Swiper,
    Lazy
} from "swiper/core";
// Install modules
SwiperCore.use([Navigation, Pagination, Scrollbar, Lazy]);
import Swal from "sweetalert2/dist/sweetalert2.js";

const Product = {
    currentVersionColor: null,
    currentId: null,
    tmpVersionId: null,
    productSwiper: null,
    hisotrySwiper: null,
    preloadImage: function(versionId) {
        // console.log('TODOs')
        // $('#product-wiz-main .swiper-slide').each(function(index) {
        //     imageSrc = $(this).find('img').attr('src')
        //     var img = new Image()
        //     img.src = imageSrc.replace(currentId, versionId)
        // })
    },
    changeColorGallery: function(versionId) {
        // console.log('TODOs')
        // if(versionId == undefined) {
        //     oldId = tmpVersionId
        //     newId = currentId
        // } else {
        //     oldId = currentId
        //     tmpVersionId = newId = versionId
        // }
        // $('#product-wiz-main .swiper-slide').each(function(index) {
        //     versionSrc = $(this).find('img').attr('src').replace(oldId, newId)
        //     $(this).find('img').attr('src', versionSrc)
        // })
    },
    init: function(items) {
        const _this = this;
        this.currentVersionColor = $(".p-colors .variants ul li.selected").attr(
            "data-color"
        );
        this.currentId = $(".p-colors .variants ul li.selected").attr(
            "data-id"
        );

        // Color Variant
        // preload color version image
        $(".p-colors .variants ul li").each(function(index) {
            _this.preloadImage($(this).attr("data-id"));
        });
        $(".p-colors .variants ul li")
            .on("mouseover", function(event) {
                $(".variant-color").text($(this).attr("data-color"));
                _this.changeColorGallery($(this).attr("data-id"));
            })
            .on("mouseleave", function(event) {
                $(".variant-color").text(_this.currentVersionColor);
                _this.changeColorGallery();
            });

        // Details
        $(".product-infoplus__item").on("click", function(event) {
            $(this).toggleClass("active");
        });
        // Sizes
        $(".sizes-selection").on("click", function(event) {
            $(this).toggleClass("active");
        });

        $("#sizes-chart").on("click", function() {
            $("#dyn-modal").modal("show");
        });

        $("#info-omnibus").on("click", function() {
            $('#omni-modal').modal('show');
        });

        $(".addToCart").on('click', function(event) {
            event.preventDefault()
            event.stopPropagation()
            window.Cart.addItem(
                $(".sku-item.selected").data("rel"),
                $(this).data("price"),
                $(this).data("currency"),
                $(this).data("id"),
                () => {
                    window.Cart.open();
                }
            );
        });

        $(".addToWishList").on("click", function(event) {
            event.preventDefault();
            event.stopPropagation();
            let type = "version";
            let id = $(this).data("rel");
            if ($(".sku.sku-item.selected").data("rel")) {
                id = $(".sku.sku-item.selected").data("rel");
                type = "sku";
            }
            $(".addToWishList").addClass("updating");
            if ($(this).hasClass("active")) {
                window.axios
                    .delete(window.PlUs.api.wishlist + "/" + id, {
                        data: {
                            type: type
                        }
                    })
                    .then(response => {
                        if (process.env.NODE_ENV === "development") {
                            console.log("removeItemToWish", response);
                        }
                        if (response.data.data.removed) {
                            $(".wishlist-quantity").html(
                                response.data.data.total
                            );
                            $(this).toggleClass("active");
                            Swal.fire({
                                position: "top-end",
                                icon: "info",
                                title:
                                    window.PlUs.strings
                                        .product_removed_to_wishlist,
                                showConfirmButton: false,
                                showCloseButton: true,
                                timer: 6000
                            });
                        } else {
                            Swal.fire({
                                icon: "error",
                                title: "Oops...",
                                text: response.data.data.message,
                                footer:
                                    window.PlUs.strings
                                        .error_adding_product_to_wishlist
                            });
                        }
                        $(".addToWishList").removeClass("updating");
                    })
                    .catch(err => {
                        $(".addToWishList").removeClass("updating");
                        console.error(err);
                        Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: window.PlUs.strings["error"],
                            footer: err
                        });
                    });
            } else {
                window.axios
                    .post(window.PlUs.api.wishlist, {
                        id,
                        type
                    })
                    .then(response => {
                        if (process.env.NODE_ENV === "development") {
                            console.log("addItemToWish", response);
                        }
                        if (response.data.data.added) {
                            $(".wishlist-quantity").html(
                                response.data.data.total
                            );
                            $(this).toggleClass("active");
                            Swal.fire({
                                position: "top-end",
                                icon: "info",
                                title:
                                    window.PlUs.strings
                                        .product_added_to_wishlist,
                                showConfirmButton: false,
                                showCloseButton: true,
                                timer: 6000
                            });

                            // fbq('track', 'AddToWishlist', {
                            //     value:  $(this).attr('data-price'),
                            //     currency: $(this).attr('data-currency'),
                            //     content_ids: 'PRODUCT_GROUP_ID',
                            //     content_type: 'product_group'
                            // });
                        } else {
                            Swal.fire({
                                icon: "error",
                                title: "Oops...",
                                text: response.data.data.message,
                                footer:
                                    window.PlUs.strings
                                        .error_adding_product_to_wishlist
                            });
                        }
                        $(".addToWishList").removeClass("updating");
                    })
                    .catch(err => {
                        $(".addToWishList").removeClass("updating");
                        console.error(err);
                        Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: this.strings["error"],
                            footer: err
                        });
                    });
            }
        });

        // Enable WL
        $(".sku").each(function(index) {
            if ($(this).hasClass("selected")) {
                $("button").prop("disabled", false);
                // $('[data-toggle="tooltip"]').tooltip('disable') // Disable tooltips
                $("#wishlist").show();
                $("#wishlist-msg").hide();
            }
        });
        $(".sku").on("click", function() {
            $(".sku").removeClass("selected");
            $(this).addClass("selected");
            $(".sizes-selection__btn .slc b").text($(this).text());
            $(".sizes-selection__btn").addClass("selected");
            $("#addToCartButton, #wishlist").prop("disabled", false);
            // $('[data-toggle="tooltip"]').tooltip('disable') // Disable tooltips
            $("#wishlist-msg").hide();
            $("#wishlist").show();
        });
        //GA4
        let productname = $(".p-name").text();
        $(".sizes-selection__btn").on("click", function() {
            dataLayer.push({
                event: "product_action",
                item_id: Product.currentId,
                item_name: productname,
                event_detail: "size_dropdown"
            });
        });
        $("#sizes-chart").on("click", function() {
            dataLayer.push({
                event: "product_action",
                item_id: Product.currentId,
                item_name: productname,
                event_detail: "size_guide"
            });
        });
        $(".product-details").on("click", function() {
            dataLayer.push({
                event: "product_action",
                item_id: Product.currentId,
                item_name: productname,
                event_detail: "tab_description"
            });
        });
        $(".spedizione").on("click", function() {
            dataLayer.push({
                event: "product_action",
                item_id: Product.currentId,
                item_name: productname,
                event_detail: "tab_shipping"
            });
        });
        $(".infospedizione").on("click", function() {
            dataLayer.push({
                event: "product_action",
                item_id: Product.currentId,
                item_name: productname,
                event_detail: "tab_shipping"
            });
        });
        $(".resoerecesso").on("click", function() {
            dataLayer.push({
                event: "product_action",
                item_id: Product.currentId,
                item_name: productname,
                event_detail: "tab_return"
            });
        });
        $(".formatcontatti").on("click", function() {
            dataLayer.push({
                event: "product_action",
                item_id: Product.currentId,
                item_name: productname,
                event_detail: "contact_us"
            });
        });
        //GA4

        this.productSwiper = new Swiper("#product-wiz-main .swiper-container", {
            lazy: {
                loadPrevNext: true
            },
            slidesPerView: 2,
            spaceBetween: 10,
            paginationBulletRender: function(index, className) {
                return (
                    '<span class="' +
                    className +
                    '">0' +
                    (index + 1) +
                    "</span>"
                );
            },
            pagination: {
                el: "#top-slider-pagination",
                type: "bullets"
            },
            navigation: {
                nextEl: ".product-next",
                prevEl: ".product-prev"
            },
            loop: true,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 0
                },
                450: {
                    slidesPerView: 1,
                    spaceBetween: 0
                },
                320: {
                    slidesPerView: 1,
                    spaceBetween: 0
                }
            }
        });

        this.hisotrySwiper = new Swiper(".history .swiper-container", {
            lazy: {
                loadPrevNext: true
            },
            slidesPerView: 5,
            navigation: {
                nextEl: ".history-next",
                prevEl: ".history-prev"
            },
            breakpoints: {
                1024: {
                    slidesPerView: 5,
                    spaceBetween: 10
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 0
                },
                450: {
                    slidesPerView: 2,
                    spaceBetween: 0
                },
                320: {
                    slidesPerView: 1,
                    spaceBetween: 0
                }
            }
        });

        // Wishlist
        // window.PlEv.addToWishList(
        //     'addToWishList',
        //     '{{ $productTranslate["name"] }}',
        //     'product',
        //     {{ $productPrice->price }},
        //     '{{ $productPrice->currency }}',
        //     '{{ route('wishlist.add') }}'
        // )

        // const pswpElement = document.querySelectorAll('.pswp')[0];
        // var options = {
        //     // optionName: 'option value'
        //     // for example:
        //     index: 0 // start at first slide
        // };

        // $('#product-wiz-main .swiper-slide').on('click', function() {
        //     const index = ($(this).attr('data-index')-1)
        //     console.log(gallery, index, items)
        //     // if(!galleryOpen) {
        //     //     galleryOpen = true
        //     // }

        //     const gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
        //     gallery.init()
        //     // gallery.goTo(index);
        // })
    }
};

export default Product;
